<template>
    <v-app>
        <div class="woodshop_board-content">
            <div class="board-left">

            </div>
            <div class="board-center">
                <h1>WOODSHOP BOARD</h1>
                <navigation-menu />
                <!--
                <departments/>
                <v-container id="departments">
                    <v-row v-for="department in departments" :key="department.id">
                        <v-card
                            class="pa-1"
                            outlined
                            tile
                        >
                        <h1>Card</h1>
                            {{department.id}}
                        </v-card>
                    </v-row>
                </v-container>-->
                <div class="statistics">
                    <div class="statistic">
                        <h2>Week</h2>
                        <martin-chart :height="180" :chart-data="datacollection" />
                    </div>
                    <div class="statistic">
                        <h2>Month</h2>
                        <martin-chart :height="180" :chart-data="datacollection" />
                    </div>
                    <div class="statistic">
                        <h2>Year</h2>
                        <martin-chart :height="180" :chart-data="datacollection" />
                    </div>
                </div>
            </div>
            <div class="board-right">
                <!--<v-autocomplete
                    v-model="selectedDepartment"

                    :items="departments"

                    item-text="name"
                    item-value="name"

                    label="Select department"

                    persistent-hint
                    return-object
                    single-line
                />

                <v-checkbox
                    v-model="useSpecificRange"
                    label="Manually pick date range"
                />

                <v-select
                    v-model="selectedRange"

                    label="Select date range"

                    :items="predefinedRanges"
                />-->
                <salestat-options />
            </div>
        </div>
    </v-app>
</template>

<script>
import '@/scss/WoodshopBoard.scss';
import NavigationMenu from '@/components/NavigationMenu.vue';
import MartinChart from '@/components/MartinChart.vue';
import SalestatOptions from '@/components/SalestatOptions.vue';

import ConvertSalesToDataset from '@/js/ConvertSalesToDataset';

export default {
    name: 'WoodShopBoard',

    components: {
        NavigationMenu,
        MartinChart,
        SalestatOptions
    },

    data() {
        return {
            datacollection: null,
            unsubscribe: null,
            path: window.location.pathname
        }
    },

    created() {
        this.unsubscribe = this.$store.subscribe((mutation) => {
            if (mutation.type == 'setSales') {
                console.warn("GOT THING")
                this.fillData()
            }
        });
    },


    mounted () {
      /*this.fillData();

      this.$store.getters.getDepartments.then(departments => {
          console.log(
              ConvertSalesToDataset(
                  departments,
                  [
                      [{"totalOrders":8,"totalProducts":144,"totalTurnover":15432,"departmentId":1}, {"totalOrders":34,"totalProducts":646,"totalTurnover":68612,"departmentId":1}],
                      [{"totalOrders":8,"totalProducts":144,"totalTurnover":15432,"departmentId":2}, {"totalOrders":34,"totalProducts":646,"totalTurnover":68612,"departmentId":2}]
                  ],
                  'totalTurnover'
              )
          )
      })*/
    },

    methods: {
      onSearchSubmitted(state) {
        console.log(state);  
      },

      fillData () {
        this.$store.getters.getDepartments.then(departments => {
            const sales = this.$store.getters.getSales;
            
            console.log(sales);
            this.datacollection = {
                labels: [1, 2, 3, 4, 5, 6, 7],
                datasets: ConvertSalesToDataset(departments, sales, 'totalTurnover'),
                responsive: true
            }  
        })
      },
      getRandomInt () {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
      }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/WoodShopBoard.vue